module.exports = __webpack_public_path__ + "static/media/loading21.72c7a128.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading21.png
// module id = 206
// module chunks = 0